export default __webpack_public_path__ + "img/pattern_vue.7bf49dec.png";